import { render } from "./GreyContainer.vue?vue&type=template&id=12b80cf0&scoped=true"
import script from "./GreyContainer.vue?vue&type=script&lang=js"
export * from "./GreyContainer.vue?vue&type=script&lang=js"

import "./GreyContainer.vue?vue&type=style&index=0&id=12b80cf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b80cf0"]])

export default __exports__